import { Outlet, NavLink } from 'react-router-dom';
import './AdminLayout.css';

const navItems = [
  { to: '/admin', end: true, label: 'Дашборд' },
  { to: '/admin/regions', end: false, label: 'Регионы' },
  { to: '/admin/animals', end: false, label: 'Животные' },
  { to: '/admin/users', end: false, label: 'Пользователи' },
  { to: '/admin/inseminators', end: false, label: 'Осименаторы/Бонитеры' },
  { to: '/admin/dna-labs', end: false, label: 'ДНК лаборатории' },
  { to: '/admin/auction', end: false, label: 'Аукцион' },
  { to: '/admin/sales-plans', end: false, label: 'План продаж' },
  { to: '/admin/feeding-areas', end: false, label: 'Откорм площадки' },
];

export default function AdminLayout() {
  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <h2>Админ-панель</h2>
        </div>
        <nav className="admin-sidebar-nav">
          {navItems.map(({ to, end, label }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `admin-sidebar-link ${isActive ? 'admin-sidebar-link--active' : ''}`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
}
